<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Mailgun account -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Token name</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Api key</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.api_key">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Use IP</label>
                <div class="col-lg-4">
                    <select class="form-control" v-model="form.use_ip">
                        <option></option>
                        <option v-for="ip in ips" :value="ip.ip">{{ ip }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Webhook domain</label>
                <div class="col-lg-4">
                    <select class="form-control" v-model="form.webhook_domain">
                        <option></option>
                        <option v-for="d in domains" :value="d.url">{{ d.url }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2" @click="check_api">Check API keys</label>
                <div class="col-lg-8">
                    <div class="form-check form-check-inline">
                        <div class="uniform-checker">
                            <span :class="{ 'checked': check_api }">
                                <input type="checkbox" class="form-check-input-styled" v-model="check_api">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{ err }}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'

export default {
    components: { modal },
    props: {
        obj: null,
        domains: {
            type: Array, default: []
        },
    },
    data() {
        return {
            form: {
                _id: null,
                name: null,
                api_key: null,
                use_ip: null,
                webhook_domain: null,
            },
            ips: [],
            err: null,
            loading: false,
            check_api: true,
        }
    },
    methods: {
        save() {

            if (!this.check_api) {
                return this._save()
            }

            this.loading = true
            this.$api.postReq('test_api_access', {
                provider: 'mailgun',
                api_key: this.form.api_key,
                use_ip: this.form.use_ip
            }).then(res => {
                this._save()
            }).catch(res => {
                this.err = 'Cannot connect to API, invalid API keys'
                this.loading = false
            })
        },
        _save() {
            this.loading = true
            this.$api.postReq('accounts/mailgun', this.form).then(res => {
                this.$emit('close')
                this.$emit('reload')
            }).catch(res => {
                this.err = res.body.error
            })
        }
    },
    mounted() {
        console.log(this.domains)
        this.loading = true
        this.$api.getReq('status/ipaddresses').then(res => {
            this.ips = res.body.ips
            this.loading = false
        })

        if (this.obj !== true) {
            this.form = this.obj
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/Mailgun.vue